import { render, staticRenderFns } from "./game-info.vue?vue&type=template&id=b9afd424"
import script from "./game-info.vue?vue&type=script&lang=js"
export * from "./game-info.vue?vue&type=script&lang=js"
import style0 from "./game-info.vue?vue&type=style&index=0&id=b9afd424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports